<template>
  <div style="padding: 5px" class="organization">
    <div class="menu">
      <header>
        <h2>{{ $t('organization.title') }}</h2>
        <a-space>
          <a-button type="primary" @click="handleSearch" v-if="authorities.find(a => a.code === 'auth:organization:query')">{{ $t('buttons.search') }}</a-button>
          <a-button type="primary" @click="handleInsert()" v-if="authorities.find(a => a.code === 'auth:organization:insert')">{{ $t('buttons.add') }}</a-button>
        </a-space>
      </header>
      <a-table
        row-key="keyId"
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="isLoading"
        :scroll="scroll"
        @change="handleTableChange"
      >
        <template v-slot:detailsName="text">
          <text-highlight :queries="[highLightInfo['details.name']]">{{text}}</text-highlight>
        </template>
        <template v-slot:pid="text">
          {{ pids[text] }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
        <template #operation="text, record">
          <a-button type="link" style="padding-left: 0" @click="handleInsert(record.id)" v-if="authorities.find(a => a.code === 'auth:organization:insert')">{{ $t('buttons.add') }}</a-button>
          <a-button type="link" style="padding-left: 0" @click="showEditModal(record)" v-if="authorities.find(a => a.code === 'auth:organization:update')">{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            v-if="authorities.find(a => a.code === 'auth:organization:delete')"
            :key="lang"
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="removeOrganization(record)"
          >
            <a href="#">{{ $t('buttons.delete') }}</a>
          </a-popconfirm>
        </template>
      </a-table>
      <a-modal v-model="visible" :title="title" :width="800" @ok="submitForm" @cancel="clearForm">
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
          <a-form-model-item :label="$t('organization.p')" prop="pid">
            <a-select
              mode="multiple"
              show-search
              v-model="form.pid"
              :default-active-first-option="false"
              :filter-option="false"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              @inputKeydown="searchO"
              @blur="() => searchPids = pids"
            >
              <a-select-option v-for="(value, key) in searchPids" :key="key" :value="key">
                {{ value }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('organization.name')" prop="zh-CN">
            <a-input v-model="form['zh-CN']" />
          </a-form-model-item>
          <a-form-model-item :label="$t('organization.code')">
            <a-input v-model="form.code" />
          </a-form-model-item>
          <a-form-model-item :label="$t('organization.enabled')">
            <a-switch v-model="form.enabled" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
const titleMap = {
  add: {
    zh: '新增组织',
    en: 'Add organization'
  },
  edit: {
    zh: '编辑组织',
    en: 'Edit organization'
  }
}

import moment from 'moment'
import {
  getOrganizationList,
  searchOrganizationList,
  addOrganization,
  updateOrganization,
  removeOrganization,
  getOrganization
} from '@/api/auth/organization'
import TextHighlight from 'vue-text-highlight'
import { nanoid } from 'nanoid'

export default {
  components: {TextHighlight},
  data() {
    return {
      data: [],
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      visible: false,
      isLoading: false,
      columns: [
        {
          title: () => (<div>{ this.$t('organization.name') }<a-input class="search" allow-clear type="text" data-index="0" /></div>),
          dataIndex: 'zh-CN',
          key: 'details.name',
          scopedSlots: {
            customRender: 'detailsName'
          }
        },
        {
          title: () => this.$t('organization.p'),
          dataIndex: 'pid',
          key: 'pid',
          scopedSlots: {
            customRender: 'pid'
          }
        },
        {
          title: () => (<div>{ this.$t('common.createdAt') }<span class="icons unset" style="cursor: pointer; right: -52px" data-index="2"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'createdAt',
          width: 200,
          key: 'createdAt'
        },
        {
          title: () => (<div>{ this.$t('common.updatedAt') }<span class="icons DESC" style="cursor: pointer; right: -52px" data-index="3"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 200
        },
        {
          title: () => this.$t('organization.enabled'),
          dataIndex: 'enabled',
          key: 'enabled',
          scopedSlots: {
            customRender: 'enabled'
          }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'left',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 1000,
        total: 0
      },
      highLightInfo: {
        'details.name': ''
      },
      pids: {
        0: '无'
      },
      authorities: [],
      sortInfo: [],
      searchInfo: {
        text: {
          protocolCode: '',
          protocolName: ''
        },
        column: {
          protocolCode: false,
          protocolName: false
        }
      },
      title: '',
      form: {
        pid: ['0'],
        code: null,
        enabled: true,
        details: [
          {
            name: '',
            description: null,
            locale: 'zh-CN'
          },
          {
            name: '',
            description: null,
            locale: 'en-US'
          }
        ],
        'zh-CN': '',
        'en-US': ''
      },
      rules: {
        pid: [
          {
            required: true,
            message: '请选择父级组织'
          }
        ],
        'zh-CN': [
          {
            required: true,
            message: this.$t('messages.eon'),
            trigger: 'blur'
          }
        ]
      },
      searchPids: {},
      scroll: {
        x: false
      }
    }
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  created() {
    this.setPids()
    this.translate()
    this.queryParams = {
      query: [],
      filter: [
        {
          field: "pid",
          value: 0
        }
      ],
      sort: [
        {
          field: 'updatedAt',
          value: 'DESC'
        }
      ]
    }
    this.title = titleMap['add'][this.lang]
  },
  mounted() {
    this.getOrganizationList()
      const ss = document.querySelectorAll('.organization .ant-table-column-title > div span.icons')
      ss.forEach(i => {
        i.addEventListener('click', () => {
          let c = ''
          switch (i.classList[1]) {
            case 'ASC':
              c = 'DESC'
              break;
            case 'DESC':
              c = 'unset'
              break;
            case 'unset':
              c = 'ASC'
              break;
            default:
              break;
          }
          i.classList.remove(i.classList[1])
          i.classList.add(c)
          const ii = document.querySelectorAll('.organization .ant-table-column-title > div span.icons:not(.unset)')
          const sort = Array.from(ii).map(item => {
            const index = +item.dataset['index']
            console.log(item.classList);
            return {
              field: this.columns[index].key,
              value: item.classList[1]
            }
          })
          this.queryParams.sort = sort
          this.searchOrganizationList()
        })
      })
      const ips = document.querySelectorAll('.search .ant-input')
      ips.forEach(ip => {
        ip.addEventListener('keyup', ({ key, target }) => {
          // console.log(key, target.value.trim())
          if (key === 'Enter') {
            target.value = target.value.trim()
            // target.value.trim() && this.handleSearch()
            this.handleSearch()
          }
        })
        ip.addEventListener('blur', ({ target }) => {
          target.value = target.value.trim()
        })
      })
      const width = window.innerWidth
      if (width < 1400) {
        this.scroll.x = 1000
      } else {
        this.scroll.x = false
      }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.setPids()
      this.translate()
    }
  },
  methods: {
    translate() {
      this.rules['zh-CN'].message = this.$t('messages.eon')
    },
    setPids() {
      const v = this.lang
      if (v === 'en') {
        this.pids[0] = 'none'
      }
      if (v === 'zh') {
        this.pids[0] = '无'
      }
    },
    async getOrganizationList() {
      this.searchOrganizationList()
    },
    handleInsert(id) {
      this.visible = true
      this.title = titleMap['add'][this.lang]
      if (id) {
        this.form.pid = [id + '']
      }
    },
    async handleSearch() {
      this.pagination.current = 1
      const ips = document.querySelectorAll('.search .ant-input')
      this.queryParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.queryParams.filter = []
          this.queryParams.query.push({
            field: this.columns[+ip.dataset['index']].key,
            value: ip.value
          })
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ip.value
        } else {
          this.queryParams.filter = [
            {
              field: 'pid',
              value: 0
            }
          ]
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ''
        }
      })
      this.searchOrganizationList()
    },
    async searchOrganizationList(callback) {
      this.isLoading = true
      try {
        const { data } = await searchOrganizationList(this.pagination.current, this.pagination.pageSize, this.queryParams)
        for (let i = 0; i < data.records.length; i++) {
          this.setTreeData(data.records[i])
        }
        this.data = data.records
        if (callback) {
          this.search = true
          await callback()
          this.pagination.current = data.current
          this.pagination.total = data.total
        } else {
          this.pagination.current = data.current
          this.pagination.total = data.total
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async handleReset(clearFilters, dataIndex) {
      clearFilters()
      this.searchInfo.text[dataIndex] = ''
      this.searchInfo.column[dataIndex] = false
      this.query.query[0].value = ''
      this.searchOrganizationList()
    },
    async removeOrganization(record) {
      try {
        const { message } = await removeOrganization(record.id)
        this.$message.success(message)
        if(this.data.length === 1 && this.data[0].id === record.id) {
          this.pagination.current = this.pagination.current === 1 ? 1 : this.pagination.current - 1
        }
        this.searchOrganizationList()
      } catch(e) {
        console.log(e)
        this.$message.error(this.$t('messages.ftd'))
      }
    },
    async submitForm() {
      try {
        const form = { ...this.form, pid: this.form.pid.map(p => +p) }
        form.details = [
          {
            name: form['zh-CN'],
            description: null,
            locale: 'zh-CN'
          },
          {
            name: form['en-US'],
            description: null,
            locale: 'en-US'
          }
        ]
        delete form["en-US"]
        delete form["zh-CN"]
        if (this.form.id) {
          const { message } = await updateOrganization(form)
          this.$message.success(message)
        } else {
          const { message } = await addOrganization(form)
          this.$message.success(message)
        }
        this.searchOrganizationList()
        this.visible = false
        this.clearForm()
      } catch(e) {
        console.log(e)
      }
    },
    async showEditModal(record) {
      this.title = titleMap.edit[this.lang]
      const { data } = await getOrganization(record.id)
      data.details.forEach(d => {
        record[d.locale] = d.name
      })
      if (!record['zh-CN']) {
        record['zh-CN'] = record['en-US']
      }
      for (let key in this.form) {
        if(key === 'pid') {
          this.form[key] = data[key].map(p => p + '')
        } else {
          this.form[key] = record[key]
        }
      }
      this.form.id = record.id
      this.visible = true
    },
    clearForm() {
      this.form = {
        pid: '0',
        code: null,
        enabled: true,
        details: [
          {
            name: '',
            description: null,
            locale: 'zh-CN'
          },
          {
            name: '',
            description: null,
            locale: 'en-US'
          }
        ],
        'zh-CN': '',
        'en-US': ''
      }
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.searchOrganizationList()
    },
    setTreeData(item) {
      item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
      item.details.forEach(d => {
        item[d.locale] = d.name
      })
      item.keyId = nanoid()
      if (!item['zh-CN']) {
        item['zh-CN'] = item['en-US']
      }
      this.pids[item.id] = item['zh-CN']
      this.searchPids = this.pids
      if (item.children && item.children.length) {
        for (let i = 0; i < item.children.length; i++) {
          this.setTreeData(item.children[i])
        }
      } else {
        item.children = null
      }
    },
    searchO(e) {
      const pids = {}
      if (e.key === 'Enter') {
        e.target.value = e.target.value.trim()
        for (let k in this.pids) {
          if (this.pids[k].includes(e.target.value)) {
            pids[k] = this.pids[k]
          }
        }
        this.searchPids = pids
      }
    }
  }
}
</script>

<style lang="less" scoped>
.menu {
  margin: 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>